import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import {
    BreakpointMatches,
    useBreakpoint,
    withBreakpoints
} from "./breakpoints.provider";

const _ConditionalBreakPoint = ({
    children,
    condition
}: RequireChildrenFor<{
    condition: (breakpoints: BreakpointMatches) => boolean;
}>) => {
    const { breakpoints } = useBreakpoint();
    if (condition(breakpoints)) {
        return <>{children}</>;
    }
    return null;
};

export const ConditionalBreakPoint = withBreakpoints(_ConditionalBreakPoint);
